'use client';

import { forwardRef, type ReactNode } from 'react';
import { RadioChoiceCardFrame, type RadioChoiceCardFrameProps } from './radio-choice-card-frame';
import { RadioChoiceCardIndicator } from './radio-choice-card-indicator';
import { RadioChoiceCardDescription, RadioChoiceCardTitle } from './radio-choice-card-text';

export type RadioChoiceCardItemProps = Omit<RadioChoiceCardFrameProps, 'children'> & {
  title: ReactNode;
  description?: ReactNode;
};

/**
 * Selectable card with a radio indicator, a title and an optional description.
 * The everyday component; build on the frame and its parts for anything richer.
 */
export const RadioChoiceCardItem = forwardRef<HTMLDivElement, RadioChoiceCardItemProps>(
  ({ title, description, ...props }, ref) => (
    <RadioChoiceCardFrame ref={ref} {...props}>
      <RadioChoiceCardIndicator />
      <div className="flex min-w-0 flex-1 flex-col">
        <RadioChoiceCardTitle>{title}</RadioChoiceCardTitle>
        {description && <RadioChoiceCardDescription>{description}</RadioChoiceCardDescription>}
      </div>
    </RadioChoiceCardFrame>
  ),
);
RadioChoiceCardItem.displayName = 'RadioChoiceCardItem';
